import api from "./api";

const userAdminService = {
  list: async (params = {}) => {
    const res = await api.get("/api/admin/users", { params });
    return res.data;
  },
  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveVendors: async () => {
    const res = await api.get("/api/admin/vendors/active");
    return res.data.data || res.data;
  },
  get: async (id) => {
    const res = await api.get(`/api/admin/users/${id}`);
    return res.data.data?.user || res.data.user || res.data;
  },
  create: async (payload) => {
    const res = await api.post("/api/admin/users", payload);
    return res.data.data?.user || res.data.user || res.data;
  },
  update: async (id, payload) => {
    const res = await api.put(`/api/admin/users/${id}`, payload);
    return res.data.data?.user || res.data.user || res.data;
  },
  remove: async (id) => {
    const res = await api.delete(`/api/admin/users/${id}`);
    return res.data;
  },
  uploadImage: async (id, file) => {
    const fd = new FormData();
    fd.append("image", file);
    const res = await api.post(`/api/admin/users/${id}/image`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data.data?.user || res.data.user || res.data;
  },
};

export default userAdminService;
